import { fetchAuthSession, getCurrentUser, type JWT } from 'aws-amplify/auth';

export interface User {
    username: string;
    userId: string;
    accessToken: JWT;
    idToken: JWT;
    tenantId: string;
}

export async function getUser(): Promise<User> {
    const { username, userId } = await getCurrentUser();

    const session = await fetchAuthSession();

    const tokens = session.tokens;
    if (!tokens) {
        throw new Error(`token not found`);
    }

    const { idToken, accessToken } = tokens;
    if (!idToken) {
        throw new Error(`id token not found`);
    }

    const tenantId = `${idToken.payload[import.meta.env.VITE_TENANT_ID_PROPERTY ?? '']}`;

    return { username, userId, accessToken, idToken, tenantId };
}

export async function getIdToken(): Promise<JWT> {
    const session = await fetchAuthSession();

    const tokens = session.tokens;
    if (!tokens) {
        throw new Error(`token not found`);
    }

    const token = tokens.idToken;
    if (!token) {
        throw new Error(`id token not found`);
    }

    return token;
}

export async function getAccessToken(): Promise<JWT> {
    const session = await fetchAuthSession();

    const tokens = session.tokens;
    if (!tokens) {
        throw new Error(`token not found`);
    }

    return tokens.accessToken;
}
